(function (upp) {
    'use strict';

    var URL_API_REST_SERVER = $UPP.URL_UPPLICATION_REST_SERVICE;
    upp.service('wireTransferService', ['appi', '$q',
        function (appi, $q) {
            var cachedWireTransfer;

            /**
             * Returns  the bank account and email of wire transfer
             *
             * @returns {Promise} Returns a promise that will be fulfilled or rejected
             */
            var getWireTransfer = function() {
                if (cachedWireTransfer) {
                    return $q.when(cachedWireTransfer)
                }

                return appi.http.get(URL_API_REST_SERVER + 'v2/wire-transfer')
                    .then(function (response) {
                        var result = {
                            bankAccount: response.data.bankAccount,
                            email: response.data.email
                        };
                        cachedWireTransfer = angular.copy(result);
                        return result
                    })
            };

            return {
                get: getWireTransfer
            };
        }]);
})(upp);


// WEBPACK FOOTER //
// ./src/app/modules/cart/services/wiretransfer-services.js